
import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { CallServiceRB } from 'rainbow-web-sdk/services/call/call.service';

export class CallsPlugin extends Plugin {
    public static initialize(): CallsPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[CallsPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[CallsPlugin] initialized");
            window.rainbow.plugins[CallsPlugin.name] = new CallsPlugin();
            CallServiceRB.getInstance();
        }
        return window.rainbow.plugins[CallsPlugin.name];
    }

    private constructor() {
        super();
    }
}
